import React from 'react';
import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    ListSubheader,
    useTheme
} from '@mui/material';
import {Link as RouterLink, useLocation} from 'react-router-dom';
import {useAppNavigation, usePageUrl} from './AppPages';

import {styled} from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {useUiState} from "./uiStore";
import {CurrentOfficeSelector} from "../components/current-office-selector/CurrentOfficeSelector";


const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    marTop: theme.spacing(2),
    padding: theme.spacing(0, 1, 0, 2),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
}));

function Sidebar() {
    const appNavigation = useAppNavigation();
    const theme = useTheme();
    const {sidebarOpen, closeSidebar, sidebarWidth} = useUiState();
    const location = useLocation();
    const pageUrl = usePageUrl();

    return (
        <Drawer
            sx={{
                width: sidebarWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: sidebarWidth,
                    boxSizing: 'border-box',
                },
            }}
            variant="persistent"
            anchor="left"
            open={sidebarOpen}
        >
            <DrawerHeader>
                <CurrentOfficeSelector/>
                <IconButton onClick={closeSidebar}>
                    {theme.direction === 'ltr' ? <ChevronLeftIcon/> : <ChevronRightIcon/>}
                </IconButton>
            </DrawerHeader>
            <Divider/>
            <Box sx={{overflow: 'auto'}}>
                {appNavigation.sidebar.map((section) => (
                    <List key={section.section}
                          disablePadding
                          subheader={
                              <ListSubheader>{section.section}</ListSubheader>
                          }
                    >
                        {section.pages.map((page) => {
                            const path = pageUrl(page);
                            return (
                                <ListItem disablePadding key={page.path}>
                                    <ListItemButton component={RouterLink} to={path}
                                                    selected={location.pathname === path || location.pathname.startsWith(path + '/')}>
                                        {page.navigation.icon && (
                                            <ListItemIcon>{page.navigation.icon}</ListItemIcon>
                                        )}
                                        <ListItemText inset={!page.navigation.icon} primary={page.navigation.label}/>
                                    </ListItemButton>
                                </ListItem>
                            );
                        })}
                    </List>
                ))}
            </Box>
        </Drawer>
    );
}

export default Sidebar;
